import localDB from "./localDB";
let GLOBAL = require('./globals');

const ClientData = {
    async all() {
        let response = await fetch(`${GLOBAL.BASE_URL}api/clients-all`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
    async add(data, res) {
        await fetch(`${GLOBAL.BASE_URL}api/clients`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(null));
    },
    async pay_debt(data, res) {
        await fetch(`${GLOBAL.BASE_URL}api/client/pay-debt`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => console.log(err));
    },
    async send_email_pay_debt(data, res) {
        await fetch(`${GLOBAL.BASE_URL}api/client/send-email-pay-debt`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => console.log(err));
    },
    async delete(id, res) {
        await fetch(`${GLOBAL.BASE_URL}api/clients/${id}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            }
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(null));
    },
    async get(id, res) {
        await fetch(`${GLOBAL.BASE_URL}api/clients/${id}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            }
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(null));
    },
    async update(data, res) {
        await fetch(`${GLOBAL.BASE_URL}api/clients/${data.id}`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(null));
    },
    async summary(id) {
        let response = await fetch(`${GLOBAL.BASE_URL}api/clients/${id}/summary`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
};

export default ClientData;



// WEBPACK FOOTER //
// ./src/data/ClientData.js